import { getLocalItem, getSessionItem, removeLocalItem, setLocalItem } from './safeStorage';

const TOKEN_KEY = 'customerModuleToken';
const USER_KEY = 'customerModuleUser';
const ADMIN_SESSION_KEY = 'adminAccessToken';

export const getAuthToken = () => getLocalItem(TOKEN_KEY) || getSessionItem(ADMIN_SESSION_KEY) || '';

export const setAuthToken = (token) => {
  setLocalItem(TOKEN_KEY, token);
};

export const clearAuthToken = () => {
  removeLocalItem(TOKEN_KEY);
};

export const setStoredUser = (user) => {
  setLocalItem(USER_KEY, JSON.stringify(user));
};

export const getStoredUser = () => {
  const raw = getLocalItem(USER_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
};

export const clearStoredUser = () => {
  removeLocalItem(USER_KEY);
};

export const decodeJwt = (token) => {
  if (!token) return null;
  const parts = token.split('.');
  if (parts.length < 2) return null;
  try {
    const payload = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const padded = payload.padEnd(payload.length + ((4 - (payload.length % 4)) % 4), '=');
    const decoded = atob(padded);
    return JSON.parse(decoded);
  } catch {
    return null;
  }
};

export const getRoleFromToken = () => {
  const token = getAuthToken();
  const payload = decodeJwt(token);
  if (!payload?.role) return '';
  return String(payload.role).replace(/-/g, '_').toUpperCase();
};
